/* Builds the structured data for the referral landing page.
 * Accepts `t` (i18n translate function) for translated FAQ schema strings.
 */
export const buildReferralStructuredData = (t) => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": t('referral.landing.faqQ1'),
        "acceptedAnswer": { "@type": "Answer", "text": t('referral.landing.faqA1') }
      },
      {
        "@type": "Question",
        "name": t('referral.landing.faqQ2'),
        "acceptedAnswer": { "@type": "Answer", "text": t('referral.landing.faqA2') }
      },
      {
        "@type": "Question",
        "name": t('referral.landing.faqQ3'),
        "acceptedAnswer": { "@type": "Answer", "text": t('referral.landing.faqA3') }
      }
    ]
  };

  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "name": "Join ProposAI via Referral",
        "description": "Join ProposAI through a trusted referral and unlock 30 days of Pro access for you and your colleague.",
        "provider": {
          "@type": "Organization",
          "name": "ProposAI",
          "url": "https://proposai.ca"
        }
      },
      faqSchema
    ]
  };
};
